export const MENU_ITEM_DRAGGABLE_CLASSNAME = 'draggableMenuItem';
